// Valores internos de counterpart_type (wire/BD) — espejo EXACTO de
// UserCounterpartType.OPTIONS_COUNTERPART_TYPES del backend y de los strings
// que emiten los CASE de sql_counterpart_type en los selectores. Son valores
// de matching (user.valid_counterparts, filtro de tipos del clasificador,
// keys de los mapas de este archivo), NO labels: el display se traduce en
// CounterpartTypePill (p.ej. 'Nota de Venta' se muestra "Nota de Ingreso").
// Renombrar uno acá o en el backend sin migrar BD + ambos lados rompe el
// clasificador (regresión e0318fd9 → 81ac651a); los specs fijan el contrato.
export const COUNTERPART_TYPE_VALUES = [
    "Cliente",
    "Proveedor",
    "Honorario",
    "Trabajador",
    "Internacional",
    "Recibo",
    "Finiquito",
    "Nota de Venta",
];

// Mapeo tipo de contraparte de gastos → obligación que usa el endpoint de
// metadata del drawer de detalle (HeaderClientDetail/BodyClientDetail).
// Proveedor/Cliente caen al bucket "Otros". Compartido por el ranking del
// modal de análisis (BodyExpensesAnalysis) y el atajo de la tabla (GastosTab),
// para no duplicar el mapa.
export const METADATA_OBLIGATION_BY_TYPE = {
    Honorario: "Boleta de Honorarios",
    Trabajador: "remuneracion-clf",
    Internacional: "invoices-clf",
    Recibo: "recibos-clf",
    Finiquito: "finiquitos-clf",
    "Nota de Venta": "notas-venta-clf",
};

export function obligationForType(counterpartType) {
    return METADATA_OBLIGATION_BY_TYPE[counterpartType] || "Otros";
}

// Tipos cuya contraparte usa un RUT placeholder compartido (66666666-6 para
// recibos y notas de venta) — el RUT no identifica a nadie, así que las vistas
// no lo muestran. Compartido por CounterpartTable y ClassifyAccountAttributes.
export const PLACEHOLDER_RUT_COUNTERPART_TYPES = ["Recibo", "Nota de Venta"];

export function hasPlaceholderRut(counterpartType) {
    return PLACEHOLDER_RUT_COUNTERPART_TYPES.includes(counterpartType);
}
